export default __webpack_public_path__ + "static/media/our-story-mobile.bb4160f3.gif";